var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconContentItaly24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#009246",
    d: "M0 0H8V16H0z",
    transform: "translate(-237 -989) translate(237 989) translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8 0H16V16H8z",
    transform: "translate(-237 -989) translate(237 989) translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE2B37",
    d: "M16 0H24V16H16z",
    transform: "translate(-237 -989) translate(237 989) translate(0 4)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContentItaly24Px);
export default __webpack_public_path__ + "static/media/icon-content-italy-24-px.d797f406.svg";
export { ForwardRef as ReactComponent };